<template>
  <div class="m-quick-btn">
    <el-popover placement="top" width="240" trigger="click" v-model="showPop">
      <slot slot="reference" name="reference"></slot>
      <div class="quick-content">
        <div class="box">
          <div class="item" :key="item.label" v-for="item in quickItems" @click="clickQuickHandle(item)">
            <svg-icon :name="`quick-${item.name}`"></svg-icon>
            <span>{{ item.label }}</span>
          </div>
        </div>
      </div>
    </el-popover>
  </div>
</template>
<script>
export default {
  data() {
    return {
      showPop: false
    };
  },
  props: {
    quickItems: {
      type: Array,
      default() {
        return [
          {
            label: "发红包",
            name: "red"
          },
          {
            label: "发悬赏",
            name: "reward"
          },
          {
            label: "发置顶",
            name: "topic"
          },
          {
            label: "发广播",
            name: "broadcast"
          }
        ];
      }
    }
  },
  methods: {
    clickQuickHandle(item) {
      this.searchVisible = true;
      this.quickType = item;
      this.showPop = false;
      this.$emit("click", item);
    }
  }
};
</script>
<style lang="scss">
.quick-content {
  .title {
    min-width: 100%;
    color: #b8c3ca;
    font-weight: 200;
    font-size: 13px;
    margin: 5px;
    padding-bottom: 10px;
    letter-spacing: 1px;
  }
  .box {
    display: flex;
    justify-content: space-between;
    .item {
      display: flex;
      justify-content: center;
      cursor: pointer;
      flex-direction: column;
      align-items: center;
    }
    svg {
      font-size: 30px;
    }
    span {
      margin-top: 5px;
      font-size: 12px;
      color: #5d6a7a;
    }
  }
}
</style>
